module.exports = __webpack_public_path__ + "static/media/lead-active-newer.a95db772.svg";